import { render, staticRenderFns } from "./PanelCompetitionResultsLive.vue?vue&type=template&id=06fbfc71&scoped=true&"
import script from "./PanelCompetitionResultsLive.vue?vue&type=script&lang=js&"
export * from "./PanelCompetitionResultsLive.vue?vue&type=script&lang=js&"
import style0 from "./PanelCompetitionResultsLive.vue?vue&type=style&index=0&id=06fbfc71&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06fbfc71",
  null
  
)

export default component.exports